import { graphql, type Environment } from 'react-relay/legacy.js';
import commitMutation from 'relay-commit-mutation-promise';

import {
    type InitiateCallMutation,
    type InitiateCallMutation$data,
    type InitiateCallInput,
} from './__generated__/InitiateCallMutation.graphql.ts';

const mutation = graphql`
    mutation InitiateCallMutation($input: InitiateCallInput!) {
        initiateCall(input: $input) {
            success
            errors {
                message
            }
        }
    }
`;

export default function initiateCall(
    environment: Environment,
    input: InitiateCallInput
): Promise<InitiateCallMutation$data> {
    return commitMutation<InitiateCallMutation>(environment, {
        mutation,
        variables: { input },
    });
}
